import { render, staticRenderFns } from "./commonAnnouncementDetail.vue?vue&type=template&id=6a990037&scoped=true"
import script from "./commonAnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./commonAnnouncementDetail.vue?vue&type=script&lang=js"
import style0 from "./commonAnnouncementDetail.vue?vue&type=style&index=0&id=6a990037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a990037",
  null
  
)

export default component.exports